import makeIdxState from './makeIdxState';

export default {
  makeIdxState,
};



// WEBPACK FOOTER //
// webpack://idx/src/v1/parsers.js